






























































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { configClient } from "@/api/ConfigClient";
import { timeFormat, localGet, doubleNum } from "@/utils/index";
import {
  GetReleaseReq,
  ItemCUReq,
  ItemDelReq,
  PublishReleaseReq
} from "@/pbjs/external/config/config_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg } from "@/utils/request";
interface Param {
  ItemKey: string;
  Comment?: string;
  ItemVal: string;
}
@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = []; //  lee 返回数据
  @Provide() private ruleForm: Param = {
    ItemKey: "",
    Comment: "",
    ItemVal: ""
  }; //  lee form表单数据
  @Provide() private token: any = ""; //  token信息
  @Provide() private username: any = ""; // 用户userID
  @Provide() private pageIndex: number = 1; // 页码
  @Provide() private pageSize: number = 20; // 分页数
  @Provide() private pagerCount: number = 0;
  @Provide() private filterText: string = ""; // 搜索内容
  @Provide() private labelPosition: string = "right";
  @Provide() private searchForm: any = {
    ItemKey: null,
    ItemComment: null,
    Operator: null
  }; // 搜索内容
  @Provide() private configParamData: any = []; // 系统配置列表
  @Provide() private isAddParamDone: boolean = false;
  @Provide() private isAddParam: boolean = false;
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private item: Param = {
    ItemKey: "",
    Comment: "",
    ItemVal: ""
  }; // 修改条目
  @Provide() private rules: any = {
    ItemKey: [
      {
        required: true,
        message: "Pls enter the Attributes name",
        trigger: "blur"
      }
      //,{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
    ],
    ItemVal: [
      {
        required: true,
        message: "Pls enter the Attributes value",
        trigger: "blur"
      }
    ]
  }; //  规则
  @Provide() private searchFormRules: any = {
    ItemKey: [
      { required: true, message: "请输入Attributes name", trigger: "blur" }
      //,{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
    ],
    Operator: [
      { required: true, message: "请输入Operator name", trigger: "blur" }
    ]
  };
  @Provide() private pagnition: any = pagnition;

  get configData(): any {
    return this.$store.getters.PARAM_CONFIG;
  }

  private created() {
    this.token = localGet("token");
    this.username = localGet("userName");
  }

  private mounted() {}

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getRelease();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getRelease();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getRelease();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getRelease();
  }

  //  lee 查询列表
  private async getRelease() {
    const { getRelease }: any = await import("@/request/getRelease");
    console.log(getRelease, "import");
    let arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      ItemKey: this.searchForm.ItemKey,
      ItemComment: this.searchForm.ItemComment,
      Operator: this.searchForm.Operator
    };
    let res = await getRelease(arg, this);
    console.log(res, "getRelease");
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      if (_result) {
        this.resultData = _result;
        console.log(this.resultData, "listList");
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  private submitSearching() {
    this.getRelease();
  }
  // lee 展开添加新的配置参数的form表单
  private addNewParam() {
    this.isAddParam = true;
  }
  private cancelParam() {
    this.ruleForm = {
      ItemKey: "",
      Comment: "",
      ItemVal: ""
    };
    this.isAddParam = false;
  }
  // lee 提交添加新的配置参数的form表单
  private submitParam() {
    (this.$refs.ruleForm as any).validate((valid: boolean) => {
      if (valid) {
        this.addParam(0);
      } else {
        this.$message({
          message: "参数不能为空",
          type: "warning"
        });
        return false;
      }
    });
  }
  // lee  调用添加参数接口
  private addParam(type: number) {
    this.isAddParamDone = true;
    let searchRequest: any = new ItemCUReq();
    searchRequest.setCommonin(setCommon());
    //  对应apollo上的test账号，目前是test账号
    // searchRequest.setOperator("test");
    searchRequest.setOperator(this.username);
    // if(type) {
    //     searchRequest.setItemkey(this.item.ItemKey);
    //     searchRequest.setItemval(this.item.ItemVal);
    //     searchRequest.setComment(this.item.Comment);
    // }else{
    searchRequest.setItemkey(this.ruleForm.ItemKey);
    searchRequest.setItemval(this.ruleForm.ItemVal);
    searchRequest.setComment(this.ruleForm.Comment);
    // }
    configClient.createOrUpdateItem(
      searchRequest,
      {},
      (err: any, response: any) => {
        //  lee  清空编辑的条目的属性
        this.item = {
          ItemKey: "",
          Comment: "",
          ItemVal: ""
        };
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.publishParam(this.ruleForm);
            // if(type === 0) {
            (this.$refs.ruleForm as any).resetFields();
            // }
          } else if (data.commonout.code == 102) {
            this.pagerCount = 0;
            // this.userData = [];
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          console.log(err);
          if (err.code == 16) {
            this.$router.push("./login");
          }
        }
        this.isAddParamDone = false;
      }
    );
  }
  // lee 修改操作
  private editItem(param: any) {
    this.ruleForm = {
      ItemKey: param.key,
      Comment: param.comment,
      ItemVal: param.value
    };
    this.isAddParam = true;
  }
  // lee  创造title参数 20200605171549-release
  private createTitleParam() {
    let _date = new Date();
    let _arr = "1234567890abcdefghijklmnopqrstuvwxyz".split("");
    let _str = "";
    for (let i = 0; i < 6; i++) {
      _str += _arr[Math.floor(Math.random() * 37)];
    }
    return `${doubleNum(_date.getFullYear())}${doubleNum(
      _date.getMonth() + 1
    )}${doubleNum(_date.getDate())}${_str}-release`;
  }
  // lee  发布更新操作
  private publishParam(param: any) {
    let searchRequest: any = new PublishReleaseReq();
    searchRequest.setCommonin(setCommon());
    //  对应apollo上的test账号，目前是test账号
    searchRequest.setOperator(this.username);
    searchRequest.setItemkey(param.ItemKey);
    searchRequest.setTitle(this.createTitleParam());
    searchRequest.setItemval(param.ItemVal);
    searchRequest.setComment(param.Comment);
    console.log(searchRequest, "publishParam");
    configClient.publishRelease(
      searchRequest,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          console.log(data, "publishRelease");
          if (!data.commonout || data.commonout.code == 0) {
            this.$message.success("操作成功");
            // let _result = JSON.parse(data.releasejson).configurations;
            // console.log(_result);
            this.getRelease();
          } else if (data.commonout.code == 102) {
            this.pagerCount = 0;
            this.resultData = [];
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          console.log(err);
          if (err.code == 16) {
            this.$router.push("./login");
          }
        }
      }
    );
  }
}
